import React, { useState, useEffect } from 'react'
import { Select, message } from 'antd'
import CustomAvatar from "../Avatar/Avatar";

const { Option } = Select
const axios = require('axios')

/**
 * @const SelectSubproyectos
 * @description Select para los Subproyectos relacionados a un proyecto
 */

const SelectSubproyectos = (props) => {
  const {
    proyecto_id,
    proyecto_ids,
    value,
    onChange,
    placeholder = 'Seleccione el SubProyecto',
    onSelect = () => {},
    disabled = false,
    className = '',
    params = {},
    bordered,
    allowClear = true,
    mode = null,
    labelInValue = true,
    onClear = () => {}
  } = props

  const [subproyectos, setSubproyectos] = useState({
    data: [],
    page: 1,
    limit: 100,
    total: 0,
    search: null,
  })

  const getSubproyectos = ({ page, limit, search } = subproyectos) => {
    if (!proyecto_id && !proyecto_ids) return

    axios.get('/subproyectos', {
      params: {
        proyecto_id,
        proyecto_ids,
        page,
        limit,
        search,
        ...params
      },
      headers: { Authorization: sessionStorage.getItem('token') }
    })
    .then(({ data }) => setSubproyectos(data))
    .catch(err => {
      console.error(err)
      message.error(err?.response?.data?.message ?? 'Error al obtener subproyectos')
    })
  }

  useEffect(() => {
    getSubproyectos({ page: 1, limit: 100, search: null })
  }, [proyecto_id, proyecto_ids])

  useEffect(() => {
    if (value) onChange(value.value ?? value)
  }, [value])

  return (
    <Select
      bordered={bordered}
      className={className}
      disabled={disabled}
      placeholder={placeholder}
      allowClear={allowClear}
      showSearch
      filterOption={false}
      labelInValue={labelInValue}
      mode={mode}
      onSearch={search => getSubproyectos({ ...subproyectos, search })}
      onSelect={item => {
        if(mode !== 'multiple'){
          onChange(item.value)
          onSelect(item.value)
        }
      }}
      onChange={(values)=>{
        if(mode === 'multiple'){
          onChange(values)
          onSelect(values)
        }
      }}
      onClear={() => {
        onClear()
        onChange(undefined)
        onSelect(undefined)
      }}
      value={value}
    >
      {
        subproyectos.data.map(({ _id, nombre, logo, color }) => (
            <Option key={_id} value={_id}>
              <CustomAvatar
                size="small"
                url={logo ? {
                  url: axios.defaults.baseURL + "/subproyectos/logo/" + _id,
                  logo: logo.file,
                  name: nombre
                } : null}
                color={color}
                name={nombre}
              />
              {nombre}
            </Option>
        ))
      }
    </Select>
  )
}

export default SelectSubproyectos
